import React from 'react';
import { Link } from 'react-router-dom';
import useFacet from '../../../../../../Hooks/Shared/Facet/useFacet';

export function ShopSale(props) {
  const { generateLinkForFacet, shouldShowSale } = useFacet(props);

  const thisFacetClicked = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.target.parentNode.lastChild.click();
    }
  };

  const priceReducedChecked = props.passedAppFunctions?.isSale();

  if (!shouldShowSale) return null;

  return (
    <div className='filter-list'>
      <fieldset>
        <legend className='sr-only'>Sale</legend>
        <ul className='facet facet-header no-style border-0'>
          <li id='shopSaleChkBox' className='ShopSale'>
            <div className='custom-control custom-checkbox'>
              <input
                className='custom-control-input'
                type='checkbox'
                role='checkbox'
                readOnly
                aria-checked={priceReducedChecked}
                checked={priceReducedChecked}
                onKeyUp={thisFacetClicked}
                aria-labelledby='shopSaleChkBox'
              ></input>
              <label
                className='custom-control-label-nocolor custom-control-label'
                htmlFor='shopSaleChkBox'
                onClick={(e) => e.target.nextElementSibling.click()}
              >
                <span className='sr-only'>Sale</span>
              </label>
              <Link
                to={generateLinkForFacet('dil_pricereduced:"1"')}
                manual_cm_sp={props.widgetData.manualCmSp}
                tabIndex='-1'
              >
                Sale
              </Link>
            </div>
          </li>
        </ul>
      </fieldset>
    </div>
  );
}

export default ShopSale;
